<template>
	<div :class="dropMenu ? 'drop-menubar' : 'menubar'" id="layout-sidebar" v-if="showMenubar" @mousedown="stopEvent" @click="stopEvent">
		<div class="menubar-content">
			<action-panels v-if="!dropMenu"></action-panels>
			<template v-if="menu && menu.groups">
				<side-bar-menu-group v-for="g in menu.groups" :group="g" :key="g.name"></side-bar-menu-group>
			</template>
			<history-box v-if="history"></history-box>
		</div>
	</div>
</template>

<script setup lang="ts">
import type {SideMenu} from "@t/ui/Menu";
import SideBarMenuGroup from "@/ui/mouse/SideBarMenuGroup.vue";
import {computed} from "vue";
import HistoryBox from "@/ui/mouse/HistoryBox.vue";
import ActionPanels from "@/ui/action-panel/ActionPanels.vue";

const props = withDefaults(defineProps<{
	menu: SideMenu,
	history?: boolean,
	dropMenu?: boolean
}>(), { history:false, dropMenu: false });

const showMenubar = computed<boolean>(() => props.menu != null || props.history);

/**
 * Stop event bubbling to prevent root element loosing focus
 */
function stopEvent(e:MouseEvent) {
	e.stopPropagation();
}

</script>

<style>
</style>